import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.Header = React.createClass({
  componentDidMount: function() {
    let $jobModal = $('#job-modal');

    $jobModal.find('.modal-header .close').on('click', () => {
      if(Job.Data.lastSlide) {
        redirectPage()
        return;
      }

      if (this.props.hideCloseModalWarning) {
        $jobModal.modal('hide')
      } else {
        let $warning = $jobModal.find('.close-modal-warning');
        if ($warning.is(':hidden')) {
          if (window.mobilecheck() === true){
            $warning.addClass("close-modal-mobile-class");
          }
          $warning.velocity('slideDown');
          $(this).addHidden();
        }
      }
    })

    function redirectPage() {
      let jobID = Job.Data.id
      let url = ''
      let message = JSON.stringify({message_type: 'jobs_wizard', message: 'JOB_POSTING_COMPLETED', payload: jobID})

      if (JobWizardMobile.MessageChannel.sendMessage(message) == true) {
        return;
      }

      switch (Job.Data.referrer.cta) {
        case 'profile': {
          url = `/jobs/${jobID}/profilejob?successful_job=true`
        }
        case 'business_directory_card': {
          url = `/jobs/${jobID}/bcardjob?successful_job=true`
        }
        default: {
          url = `/jobs/${jobID}/posted?successful_job=true`
        }
      }
      document.location.href = url 
    }
  },
  render: function() {
    return (
      <div className="modal-header question-header no-border-bottom">
        <button type="button" className="close visible-xs" aria-label="Close" style={{top: '-18px', right:'20px', position:'absolute'}}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    )
  }
})
